import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../../../packages';

export const useStyles = makeStyles({
  drawer: {
    '& .MuiPaper-root': {
      maxWidth: '733px !important',
    },
    '& .drawerBody': {
      padding: 0,
    },
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  header: {
    position: 'relative',
    padding: '16px 8px 24px 24px',
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  closeBtn: {
    margin: 0,
    minWidth: 'auto',
    position: 'absolute',
    right: 24,
    top: 24,
    '& svg': {
      width: 30,
    },
  },
  stepWrap: {
    marginTop: 20,
    '& .Mui-completed': {
      '& #stepCircle': {
        background: '#000000',
        border: '2px solid #ffffff',
      },
    },
  },
  filterText: {
    padding: '5px',
  },
  insuranceText: {
    display: 'inline-block',
    fontSize: 16,
    width: 120,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  valueText: {
    maxWidth: 114,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  insuranceText2: {
    fontSize: 16,
  },
  insuranceIcon: {
    width: 16,
    height: 16,
  },
  noInsuranceIcon: {
    width: 20,
    height: 20,
  },
  nextAppointmentIcon: {
    width: 24,
    height: 24,
  },
  providerProfile: {
    width: '48%',
  },
  searchInput: {
    height: 48,
  },
  error: {
    textAlign: 'center',
    color: `${colors.destructive500} !important`,
  },
  emptyList: {
    textAlign: 'center',
    color: colors.neutral400,
    display: 'inline-block',
    width: '100%',
    margin: '32px 0',
  },
  badge: {
    fontSize: 12,
    height: 18,
  },
  providerInfo: {
    borderRadius: 8,
    border: '1px solid',
    borderColor: colors.neutral200,
    padding: 24,
    display: 'flex',
    gap: 80,
    cursor: 'pointer',
  },
  nickName: {
    fontSize: 14,
    color: colors.neutral900,
    lineHeight: '20px',
  },
  fullName: {
    fontSize: 14,
    color: colors.neutral600,
    display: 'block',
  },
  loadMoreBtn: {
    fontSize: 14,
  },
  heading: {
    color: colors.neutral900,
    fontSize: 22,
    fontWeight: 600,
    lineHeight: '28px',
    letterSpacing: '-0.22px',
  },
  bookNewProviderBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '24px',
    border: `1px solid ${colors.neutral200}`,
    borderRadius: '8px',
    cursor: 'pointer',
  },
  bookNewProviderIcon: {
    width: 40,
    height: 40,
  },
  bookNewProviderText: {
    fontSize: 16,
    color: colors.primary600,
    fontWeight: 600,
    lineHeight: '24px',
    cursor: 'pointer',
  },
  providerList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  userinfo: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: '670px',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '24px 20px',
    gap: 24,
    '&:not(:last-child)': {
      borderBottom: `1px solid ${colors.neutral100}`,
    },
    '&:hover': {
      backgroundColor: colors.primary25,
      borderRadius: 12,
      border: `1px solid #B8DDFE !important`,
    },
  },
  selected: {
    backgroundColor: colors.primary100,
    borderRadius: 12,
    border: `1px solid #B8DDFE !important`,
  },
  providerRole: {
    borderRadius: 20,
    height: 18,
    padding: '2px 8px',
    fontSize: 12,
    width: 'fit-content',
    border: 'none',
    marginTop: 2,
    textWrap: 'nowrap',
  },
  linkButton: {
    width: '100%',
    border: `1px solid ${colors.primary300}`,
    borderRadius: '6px',
  },
  alignEnd: {
    textAlign: 'end',
  },
});
